export default function (callback, that) {
    var index = -1;
    for (var _i = 0, _a = this; _i < _a.length; _i++) {
        var node = _a[_i];
        if (callback.call(that, node, ++index, this)) {
            return node;
        }
    }
}
